enum Emails {
    SALES_EMAIL = 'sales@dotyeti.com',
    SUPPORT_EMAIL = 'hello@dotyeti.com',
    GREGORY_EMAIL = 'gregory@dotyeti.com',
}

export default Emails;
